import { render, staticRenderFns } from "./CountYear.vue?vue&type=template&id=2c0f1189&scoped=true&"
import script from "./CountYear.vue?vue&type=script&lang=js&"
export * from "./CountYear.vue?vue&type=script&lang=js&"
import style0 from "./CountYear.vue?vue&type=style&index=0&id=2c0f1189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0f1189",
  null
  
)

export default component.exports